import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function NaturePeopleIcon(props: IconProps) {
    return <Icon {...props} iconKey={"nature_people"}/>
}
